import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Companion_getInstance14tgug8r8maei as Companion_getInstance } from '../ExecutionContext.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { trim11nh7r46at6sx as trim } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  HttpMethod_Get_instance = new (HttpMethod())('Get', 0);
  HttpMethod_Post_instance = new (HttpMethod())('Post', 1);
  HttpMethod_Query_instance = new (HttpMethod())('Query', 2);
}
var HttpMethod_Get_instance;
var HttpMethod_Post_instance;
var HttpMethod_Query_instance;
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var HttpHeaderClass;
function HttpHeader() {
  if (HttpHeaderClass === VOID) {
    class $ {
      constructor(name, value) {
        this.u4b_1 = name;
        this.v4b_1 = value;
      }
      toString() {
        return 'HttpHeader(name=' + this.u4b_1 + ', value=' + this.v4b_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.u4b_1);
        result = imul(result, 31) + getStringHashCode(this.v4b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpHeader()))
          return false;
        if (!(this.u4b_1 === other.u4b_1))
          return false;
        if (!(this.v4b_1 === other.v4b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpHeader');
    HttpHeaderClass = $;
  }
  return HttpHeaderClass;
}
function _get_hasBody__xziwnf($this) {
  return !($this.x4b_1 == null) || !($this.y4b_1 == null);
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(statusCode) {
        this.w4b_1 = statusCode;
        this.x4b_1 = null;
        this.y4b_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.z4b_1 = ArrayList().p2();
        this.a4c_1 = Companion_getInstance().y42_1;
      }
      b4c(bodySource) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!!_get_hasBody__xziwnf(this)) {
          var message = 'body() can only be called once';
          throw IllegalStateException().o(toString(message));
        }
        this.x4b_1 = bodySource;
        return this;
      }
      k4b(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.z4b_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.j2(element);
        return this;
      }
      m4b(headers) {
        // Inline function 'kotlin.apply' call
        this.z4b_1.u2(headers);
        return this;
      }
      e3a() {
        return new (HttpResponse())(this.w4b_1, this.z4b_1, this.x4b_1, this.y4b_1, this.a4c_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      constructor(statusCode, headers, bodySource, bodyString, executionContext) {
        this.c4c_1 = statusCode;
        this.d4c_1 = headers;
        this.e4c_1 = bodySource;
        this.f4c_1 = bodyString;
        this.g4c_1 = executionContext;
      }
      h4c() {
        var tmp0_elvis_lhs = this.e4c_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.f4c_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = (new (Buffer())()).p3z(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(method, url) {
        this.f4b_1 = method;
        this.g4b_1 = url;
        this.h4b_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.i4b_1 = ArrayList().p2();
        this.j4b_1 = Companion_getInstance().y42_1;
      }
      l4b(body) {
        // Inline function 'kotlin.apply' call
        this.h4b_1 = body;
        return this;
      }
      k4b(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.i4b_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.j2(element);
        return this;
      }
      m4b(headers) {
        // Inline function 'kotlin.apply' call
        this.i4b_1.u2(headers);
        return this;
      }
      s44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.j4b_1 = this.j4b_1.t44(executionContext);
        return this;
      }
      e3a() {
        return new (HttpRequest())(this.f4b_1, this.g4b_1, this.i4b_1, this.h4b_1, this.j4b_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {
      constructor(method, url, headers, body, executionContext) {
        this.i4c_1 = method;
        this.j4c_1 = url;
        this.k4c_1 = headers;
        this.l4c_1 = body;
        this.m4c_1 = executionContext;
      }
      n4c(method, url) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Builder_0())(method, url);
        if (!(this.l4c_1 == null)) {
          this_0.l4b(this.l4c_1);
        }
        this_0.m4b(this.k4c_1);
        this_0.s44(this.m4c_1);
        return this_0;
      }
      o4c(method, url, $super) {
        method = method === VOID ? this.i4c_1 : method;
        url = url === VOID ? this.j4c_1 : url;
        return $super === VOID ? this.n4c(method, url) : $super.n4c.call(this, method, url);
      }
    }
    initMetadataForClass($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
function get(_this__u8e3s4, name) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.singleOrNull' call
    var single = null;
    var found = false;
    var _iterator__ex2g4s = _this__u8e3s4.p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = element.u4b_1.toLowerCase();
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      if (tmp === name.toLowerCase()) {
        if (found) {
          tmp$ret$0 = null;
          break $l$block_0;
        }
        single = element;
        found = true;
      }
    }
    if (!found) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    tmp$ret$0 = single;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.v4b_1;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp_0 = toString(trim(isCharSequence(tmp1_safe_receiver) ? tmp1_safe_receiver : THROW_CCE()));
  }
  return tmp_0;
}
function HttpMethod_Get_getInstance() {
  static_init();
  return HttpMethod_Get_instance;
}
function HttpMethod_Post_getInstance() {
  static_init();
  return HttpMethod_Post_instance;
}
function HttpMethod_Query_getInstance() {
  static_init();
  return HttpMethod_Query_instance;
}
//region block: exports
export {
  HttpHeader as HttpHeader1d7ldebjomr00,
  Builder_0 as Builder2ocxamygt14i4,
  Builder as Builder1mo34du82b3c6,
  get as get3c0ofj2dgi8ma,
  HttpMethod_Get_getInstance as HttpMethod_Get_getInstancek26a5f4rdtug,
  HttpMethod_Post_getInstance as HttpMethod_Post_getInstance3lyly75k5cb7q,
  HttpMethod_Query_getInstance as HttpMethod_Query_getInstance37rv8t07hm7h7,
};
//endregion

//# sourceMappingURL=Http.mjs.map
